import React from 'react'
import { graphql } from 'gatsby'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { titleCase } from 'title-case'
// import { icon } from '@fortawesome/fontawesome-svg-core'
import Icon from '../../components/Icons/index.js'

import SEO from '../../components/SEO'
import Nav from '../../components/Nav'
import Styles from '../../styles/doc.module.scss'
import Footer from '../../components/Footer'

const headerMap = {
  Experience: {
    title: 'End-User Experiences',
    glyph: 'NAV_EXPERIENCE_OVERVIEW',
  },
  Workflow: {
    title: 'Workflow Engine',
    glyph: 'NAV_WORKFLOWS',
  },
  Dashboard: {
    title: 'Dashboards',
    glyph: 'NAV_DASHBOARDS',
  },
  Edge: {
    title: 'Edge Compute',
    glyph: 'EDGE_COMPUTE',
  },
  Device: {
    title: 'Devices and Data Sources',
    glyph: 'NAV_DEVICES',
  },
  Application: {
    title: 'Application Management',
    glyph: 'NAV_APPLICATIONS',
  },
}

const Tutorials = ({ location, data }) => {
  const allTutorials = data.allMdx.nodes

  const Cards = styled.ul`
    @media screen and (min-width: 1050px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media screen and (max-width: 900px) {
      grid-template-columns: repeat(1, 1fr);
    }
    display: grid;
    grid-gap: 1.7rem;
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
    padding-left: 0px;
  `

  const Card = styled.div`
    display: inline-block;
    overflow: hidden;
    color: #444444;
    background-color: #f5f6f7;
    text-decoration: none !important;
    grid-area: body;
    border-bottom: 5px solid #284fff;
  `

  const CardHeader = styled.p`
    background-color: #284fff;
    color: #fff;
    padding: 0 15px;
    font-family: 'Alternate Gothic', 'Franklin Gothic Medium';
    margin: 0;
    font-size: 15px;
    text-transform: uppercase;
    display: flex;
    grid-area: header;
  `

  const buildCards = (guide) => {
    return (
      <a
        css={css`
          text-decoration: none !important;
        `}
        key={guide.id}
        href={guide.fields.slug}
      >
        <div
          css={css`
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: 50px 400px;
            grid-template-areas:
              'header'
              'body';
          `}
        >
          <CardHeader
            css={css`
              grid-area: header;
            `}
          >
            <p
              css={css`
                font-size: 1.2rem;
                align-self: center;
              `}
            >
              {headerMap[guide.frontmatter.component].title}
            </p>
            <p
              css={css`
                margin-left: auto;
                align-self: center;
                padding-top: 5px;
              `}
            >
              <Icon
                glyph={headerMap[guide.frontmatter.component].glyph}
                placement="header"
              />
            </p>
          </CardHeader>
          <Card
            css={css`
              padding: 15px 25px 25px 25px;
              margin-top: 0px;
              grid-area: body;
              display: grid;
              grid-template-columns: 100%;
              grid-template-rows: auto auto auto;
              grid-template-areas:
                'title'
                'description'
                'image';
            `}
          >
            <h2
              css={css`
                margin-top: 0px;
                font-family: 'Alternate Gothic', 'Franklin Gothic Medium',
                  'Arial Narrow', sans-serif;
                -webkit-font-smoothing: antialiased;
                color: #284fff;
                font-weight: normal;
                font-size: 1.8rem;
                margin-bottom: 0;
                grid-area: title;
                align-self: start;
                padding-top: 5px;
              `}
            >
              {titleCase(guide.frontmatter.title)}
            </h2>
            <p
              css={css`
                font-size: 0.875rem;
                line-height: 1.5;
                margin: 0 !important;
                grid-area: description;
                align-self: start;
                justify-self: start;
              `}
            >
              {guide.frontmatter.description}
            </p>
            <div
              css={css`
                text-align: center;
              `}
            >
              <img
                css={css`
                  width: 95%;
                  height: auto;
                  grid-area: image;
                  align-self: center;

                  // @media screen and (max-width: 900px) {
                  //   width: 80%;
                  // }
                `}
                src={guide.frontmatter.image}
                alt={guide.frontmatter.title}
              />
            </div>
          </Card>
        </div>
      </a>
    )
  }

  const TutorialList = allTutorials.map(buildCards)
  // const WalkthroughList = walkthroughs.map(buildCards)

  return (
    <>
      <SEO
        title="How-to Guides"
        description="Losant How-to Guides provide walkthroughs and tutorials that demonstrate a variety of platform features."
        keywords={['Losant How-to Guides', 'Losant Walkthroughs']}
      />
      <Nav location={location} />
      <div style={{ padding: '40px' }} className={Styles.DocWrapper}>
        <div
          css={css`
            -webkit-box-flex: 1;
            flex-grow: 1;
            display: flex;
            height: 100%;
            justify-content: center;
            padding: 0px 20px;
            width: 1px;
          `}
        >
          <div
            css={css`
              min-height: 100%;
              max-width: 740px;
              font-family: 'Fira Sans', 'Lucida Grande', 'Trebuchet MS',
                sans-serif;
              -webkit-font-smoothing: antialiased;
              color: #111a2b;
              width: 100%;
            `}
            style={{ maxWidth: '1200px' }}
            role="main"
          >
            <div
              css={css`
                .pageHeader {
                  display: table;
                }

                & > .pageHeader h1 {
                  vertical-align: middle;
                  display: table-cell;
                  font-family: 'Alternate Gothic', 'Franklin Gothic Medium',
                    'Arial Narrow', sans-serif;
                  -webkit-font-smoothing: antialiased;
                  color: #ff495c;
                  font-size: 1.2rem;
                  font-weight: normal;
                  margin-bottom: 0;
                  margin-top: 0;
                }
              `}
            >
              <div className="pageHeader">
                <Icon glyph="GUIDE" placement="red" />
                <h1>How-to Guides</h1>
              </div>
            </div>
            <Cards>{TutorialList}</Cards>
            <Footer />
          </div>
        </div>
      </div>
    </>
  )
}

export default Tutorials

export const pageQuery = graphql`
  query tutorialsAndWalkthroughs {
    allMdx(
      filter: {
        frontmatter: { category: { eq: "How-to Guide" }, main: { ne: false } }
      }
      sort: { fields: [frontmatter___title], order: ASC }
    ) {
      nodes {
        id
        frontmatter {
          title
          description
          category
          component
          date
          image
          resources {
            name
            url
          }
        }
        excerpt
        rawBody
        fields {
          slug
        }
      }
    }
  }
`
